/**
 * @flow
 * */

import React from 'react'

import { SectionHeading } from '../styedComponents.js'

import TeamCount from './TeamCount.js'
import {
  TeamProfilesContainer,
  TeamProfilesSection,
  TeamProfilesCardContainer,
  TeamProfilesImage,
  TeamProfilesName,
  TeamProfiles,
  TeamProfilesDesignation,
  TeamProfilesUniversity,
  TeamProfileContent
} from './styledComponents'

type Props = {
  coreTeamData: Object
}

class ProductCard extends React.PureComponent<Props> {
  render() {
    const { coreTeamData } = this.props
    const { heading, manyMoreText, teamMembersList } = coreTeamData

    return (
      <TeamProfilesSection id="proyuga-team-profiles">
        <TeamProfilesContainer>
          <SectionHeading as="h3">{heading}</SectionHeading>
          <TeamProfiles>
            {teamMembersList.map(eachTeamMember => (
              <TeamProfilesCardContainer key={eachTeamMember.name}>
                <TeamProfilesImage
                  dataSrc={eachTeamMember.picUrl}
                  alt={eachTeamMember.name}
                  className="lazyload"
                />
                <TeamProfileContent>
                  <TeamProfilesName as="article">
                    {eachTeamMember.name}
                  </TeamProfilesName>
                  <TeamProfilesDesignation as="article">
                    {eachTeamMember.position}
                  </TeamProfilesDesignation>
                  <TeamProfilesUniversity as="article">
                    {eachTeamMember.college}
                  </TeamProfilesUniversity>
                </TeamProfileContent>
              </TeamProfilesCardContainer>
            ))}
          </TeamProfiles>
        </TeamProfilesContainer>
        <TeamCount teamCountContent={manyMoreText} />
      </TeamProfilesSection>
    )
  }
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/components/TeamNew/TeamProfiles/index.js